import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '../i18n';

Vue.use(Vuex)

// Configuration constants for UI display limits
const UI_LIMITS = {
  HOME_BLOG_POSTS: 4, // Number of blog posts to show on home page (excluding priority post)
  BLOG_CARDS_MAX: 4,  // Maximum blog cards to display in card sections
  AKTIVITAS_CONTACTS: 5, // Number of Aktivitas contact cards to show
  PHILISTER_CONTACTS_START: 5, // Starting index for Philister contacts
  PHILISTER_CONTACTS_END: 13,   // Ending index for Philister contacts
  BLOG_FEED_START: 1 // Skip welcome post at index 0 for blog feed
};

export default new Vuex.Store({
  state: {
    language: 'de',
    welcomeScreen: {
      title: i18n.t(`welcomeScreen.title`),
      blogPost: i18n.t(`welcomeScreen.blogPost`),
      welcomeScreen: true,
      photo: "hauptseite/hauptseite-willkommen",
    },
    contactCardsArray: [
      // Aktivitas SS 2026
      { chargeTitle: "Senior \n(x)", chargeName: "Armin Piela \nS-Ss!", chargeContact: "+48 724 049 547", chargeMail: "x@salia-silesia.eu", chargePhoto: "xd" },
      { chargeTitle: "Consenior \n(xx)", chargeName: "Robert Piosek \nS-Ss!", chargeContact: "+48 692 830 622", chargeMail: "xx@salia-silesia.eu", chargePhoto: "robert-piosek/robert-piosek" },
      { chargeTitle: "Fuxmajor \n(FM)", chargeName: "Thomas Kusiek \nS-Ss!", chargeContact: "+48 884 120 167", chargeMail: "fm@salia-silesia.eu", chargePhoto: "thomas-kusiek/thomas-kusiek-fm" },
      { chargeTitle: "Scriptor \n(xxx)", chargeName: "Rafael Wawrzynek \nS-Ss!", chargeContact: "+48 503 879 170", chargeMail: "xxx@salia-silesia.eu", chargePhoto: "rafal-wawrzynek/rafal-wawrzynek-1" },
      { chargeTitle: "Quaestor \n(xxxx)", chargeName: "Michael Gorgosch \nS-Ss!", chargeContact: "+48 667 927 669", chargeMail: "xxxx@salia-silesia.eu", chargePhoto: "michael-gorgosch/michael-gorgosch" },

      // Altherrenvorstand SS 2026
      { chargeTitle: "Philister-Senior \n(Phil-x)", chargeName: "Damian Schwider", chargeContact: "+48 508 404 970", chargeMail: "phil.x@salia-silesia.de", chargePhoto: "xd" },
      { chargeTitle: "Philister-Consenior OS \n(Phil-xx)", chargeName: "Roland Cedzich", chargeContact: "+48 600 926 850", chargeMail: "phil.xx.os@salia-silesia.de", chargePhoto: "xd" },
      { chargeTitle: "Philister-Consenior WEST \n(Phil-xx WEST)", chargeName: "Robert Piecuch", chargeContact: "+49 163 840 9563", chargeMail: "phil.xx@salia-silesia.de", chargePhoto: "xd" },
      { chargeTitle: "Philister-Scriptor \n(Phil-xxx)", chargeName: "Markus Heller", chargeContact: "+49 173 383 5315", chargeMail: "phil.xxx@salia-silesia.de", chargePhoto: "xd" },
      { chargeTitle: "Philister-Quaestor / GVB \n(Phil-xxxx)", chargeName: "Franz Josef Ziegler", chargeContact: "+49 894 201 7791", chargeMail: "phil.xxxx@salia-silesia.de", chargePhoto: "xd" },
      { chargeTitle: "Philister-Quaestor OS \n(Phil-xxxx OS)", chargeName: "Hubert Beier", chargeContact: "+48 604 554 700", chargeMail: "phil.xxxx.os@salia-silesia.de", chargePhoto: "xd" },
      { chargeTitle: "Seelsorger \nder Verbindung", chargeName: "Arnold Nowak", chargeContact: "+48 604 107 358", chargeMail: "seelsorger@salia-silesia.de", chargePhoto: "arnold-nowak/arnold-nowak" }
    ],
    blogCardsArray: [
      { blogID: 6, blogTitle: i18n.t(`blogPostArray[6].blogTitle`), blogCoverPhoto: "zimmer-frei", blogDate: "September 18, 2022" },
      { blogID: 7, blogTitle: i18n.t(`blogPostArray[7].blogTitle`), blogCoverPhoto: "spectrum-article", blogDate: "Juni 23, 2022" },
      { blogID: 8, blogTitle: i18n.t(`blogPostArray[8].blogTitle`), blogCoverPhoto: "wochenblatt-article", blogDate: "April 7, 2025" },
      { blogID: 9, blogTitle: i18n.t(`blogPostArray[9].blogTitle`), blogCoverPhoto: "wochenblatt-freies-denken", blogDate: "Mai 24, 2025" },
      { blogID: 10, blogTitle: i18n.t(`blogPostArray[10].blogTitle`), blogCoverPhoto: "wochenblatt-33-jahre", blogDate: "Juni 14, 2025" },
      { blogID: 11, blogTitle: i18n.t(`blogPostArray[11].blogTitle`), blogCoverPhoto: "wochenblatt-pilgrim", blogDate: "Juni 4, 2025" },
      { blogID: 12, blogTitle: i18n.t(`blogPostArray[12].blogTitle`), blogCoverPhoto: "wochenblatt-rheno-palatia", blogDate: "Juni 28, 2025" },
      { blogID: 13, blogTitle: i18n.t(`blogPostArray[13].blogTitle`), blogCoverPhoto: "wochenblatt-schlesien-herzen", blogDate: "August 4, 2025" },
      { blogID: 14, blogTitle: i18n.t(`blogPostArray[14].blogTitle`), blogCoverPhoto: "dfk-lubowice-35-anniversary", blogDate: "September 13, 2025" },
    ],
    blogPostArray: [
      {
        blogID: 0,
        blogTitle: i18n.t(`blogPostArray[0].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[0].blogPreview`),
        blogHTML: null,
        blogCoverPhoto: "old-salia",
        blogAdditionalPhotos: null,
      },
      {
        blogID: 1,
        blogTitle: i18n.t(`blogPostArray[1].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[1].blogPreview`),
        blogHTML: [
          {
            chapterTitle: i18n.t(`blogPostArray[1].blogHTML[0].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[1].blogHTML[0].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[1].blogHTML[1].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[1].blogHTML[1].chapterHTML`),
            chapterPhotos: [
              "uber-uns/cathedral",
              "uber-uns/technische-universitat",
              "uber-uns/amicitia",
              "uber-uns/schlesien-karte",
              "uber-uns/oppeln"
            ],
          }
        ],
        slideshowImages: [
          require("../assets/blogPhotos/chapterPhotos/uber-uns/cathedral.jpg"),
          require("../assets/blogPhotos/chapterPhotos/uber-uns/technische-universitat.jpg"),
          require("../assets/blogPhotos/chapterPhotos/uber-uns/amicitia.jpg"),
          require("../assets/blogPhotos/chapterPhotos/uber-uns/schlesien-karte.jpg"),
          require("../assets/blogPhotos/chapterPhotos/uber-uns/oppeln.jpg"),              
        ],
        blogCoverPhoto: "hauptseite/hauptseite-unsere-prinzipien",
        blogAdditionalPhotos: null,
        aboutUs: true,
      },
      {
        blogID: 2,
        blogTitle: i18n.t(`blogPostArray[2].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[2].blogPreview`),
        blogHTML: null,
        blogCoverPhoto: "hauptseite-old/semesterprogramm",
        blogAdditionalPhotos: null,
        program: true,
      },
      {
        blogID: 3,
        blogTitle: i18n.t(`blogPostArray[3].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[3].blogPreview`),
        blogHTML: [
          {
            chapterTitle: i18n.t(`blogPostArray[3].blogHTML[0].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[3].blogHTML[0].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[3].blogHTML[1].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[3].blogHTML[1].chapterHTML`),
            chapterPhotos: [
              "geschichte/grundung-1",
              "geschichte/grundung-2",
              "geschichte/grundung-3",
            ]
          },
          {
            chapterTitle: i18n.t(`blogPostArray[3].blogHTML[2].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[3].blogHTML[2].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[3].blogHTML[3].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[3].blogHTML[3].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[3].blogHTML[4].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[3].blogHTML[4].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[3].blogHTML[5].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[3].blogHTML[5].chapterHTML`),
            chapterPhotos: [
              "geschichte/merk-poster",
              "geschichte/merk-leute",
            ]
          },
          {
            chapterTitle: i18n.t(`blogPostArray[3].blogHTML[6].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[3].blogHTML[6].chapterHTML`),
            chapterPhotos: [
              "geschichte/breslau-kommers"
            ]
          },
          {
            chapterTitle: i18n.t(`blogPostArray[3].blogHTML[7].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[3].blogHTML[7].chapterHTML`),
          },
        ],
        slideshowImages: [
          require("../assets/blogPhotos/chapterPhotos/geschichte/grundung-1.jpg"),
          require("../assets/blogPhotos/chapterPhotos/geschichte/grundung-2.jpg"),
          require("../assets/blogPhotos/chapterPhotos/geschichte/grundung-3.jpg"),
          require("../assets/blogPhotos/chapterPhotos/geschichte/merk-poster.jpg"),
          require("../assets/blogPhotos/chapterPhotos/geschichte/merk-leute.jpg"),
          require("../assets/blogPhotos/chapterPhotos/geschichte/breslau-kommers.jpg"),            
        ],
        blogCoverPhoto: "hauptseite/hauptseite-geschichte",
        blogAdditionalPhotos: null,
        history: true,
      },
      {
        blogID: 4,
        blogTitle: i18n.t(`blogPostArray[4].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[4].blogPreview`),
        blogHTML: null,
        blogCoverPhoto: "hauptseite/hauptseite-kontakt",
        blogAdditionalPhotos: null,
        contact: true,
      },
      {
        blogID: 5,
        blogTitle: i18n.t(`blogPostArray[5].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[5].blogPreview`),
        blogHTML: [
          {
            chapterTitle: i18n.t(`blogPostArray[5].blogHTML[0].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[5].blogHTML[0].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[5].blogHTML[1].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[5].blogHTML[1].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[5].blogHTML[2].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[5].blogHTML[2].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[5].blogHTML[3].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[5].blogHTML[3].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[5].blogHTML[4].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[5].blogHTML[4].chapterHTML`),
          },
        ],
        blogCoverPhoto: "hauptseite-old/salia-wappen",
        blogAdditionalPhotos: null,
      },
      {
        blogID: 6,
        blogTitle: i18n.t(`blogPostArray[6].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[6].blogPreview`),
        blogHTML: [
          {
            chapterTitle: i18n.t(`blogPostArray[6].blogHTML[0].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[6].blogHTML[0].chapterHTML`),
            chapterPhotos: [
              "zimmer-frei/zimmer-frei-1",
              "zimmer-frei/zimmer-frei-2",
              "zimmer-frei/zimmer-frei-3",
              "zimmer-frei/zimmer-frei-4",
              "zimmer-frei/zimmer-frei-5",
              "zimmer-frei/zimmer-frei-6",
              "zimmer-frei/zimmer-frei-7",
              "zimmer-frei/zimmer-frei-8",
            ]
          },
        ],
        slideshowImages: [
          require("../assets/blogPhotos/chapterPhotos/zimmer-frei/zimmer-frei-1.jpg"),
          require("../assets/blogPhotos/chapterPhotos/zimmer-frei/zimmer-frei-2.jpg"),
          require("../assets/blogPhotos/chapterPhotos/zimmer-frei/zimmer-frei-3.jpg"),
          require("../assets/blogPhotos/chapterPhotos/zimmer-frei/zimmer-frei-4.jpg"),
          require("../assets/blogPhotos/chapterPhotos/zimmer-frei/zimmer-frei-5.jpg"),
          require("../assets/blogPhotos/chapterPhotos/zimmer-frei/zimmer-frei-6.jpg"),
          require("../assets/blogPhotos/chapterPhotos/zimmer-frei/zimmer-frei-7.jpg"),
          require("../assets/blogPhotos/chapterPhotos/zimmer-frei/zimmer-frei-8.jpg"),
        ],
        blogCoverPhoto: "hauptseite/hauptseite-zimmer-frei",
        blogAdditionalPhotos: null,
        zimmerFrei: true,
      },
      {
        blogID: 7,
        blogTitle: i18n.t(`blogPostArray[7].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[7].blogPreview`),
        blogHTML: [
          {
            chapterTitle: i18n.t(`blogPostArray[7].blogHTML[0].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[7].blogHTML[0].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[7].blogHTML[1].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[7].blogHTML[1].chapterHTML`),
          }
        ],
        blogCoverPhoto: "external-articles/spectrum-article",
        blogAdditionalPhotos: null,
        sourceLink: "https://www.spectrum.direct/post/studentami-nikt-sie-nie-zainteresowal#",
        externalSource: true,
      },
      {
        blogID: 8,
        blogTitle: i18n.t(`blogPostArray[8].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[8].blogPreview`),
        blogHTML: [
          {
            chapterTitle: i18n.t(`blogPostArray[8].blogHTML[0].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[8].blogHTML[0].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[8].blogHTML[1].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[8].blogHTML[1].chapterHTML`),
          }
        ],
        blogCoverPhoto: "external-articles/wochenblatt-article",
        blogAdditionalPhotos: null,
        sourceLink: "http://wochenblatt.pl/de/vortrag-flucht-und-vertreibung-zwischen-den-kriegen/",
        externalSource: true,
      },
      {
        blogID: 9,
        blogTitle: i18n.t(`blogPostArray[9].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[9].blogPreview`),
        blogHTML: [
          {
            chapterTitle: i18n.t(`blogPostArray[9].blogHTML[0].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[9].blogHTML[0].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[9].blogHTML[1].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[9].blogHTML[1].chapterHTML`),
          }
        ],
        blogCoverPhoto: "external-articles/wochenblatt-freies-denken",
        blogAdditionalPhotos: null,
        sourceLink: "https://wochenblatt.pl/de/ausdruck-eines-freien-denkens/",
        externalSource: true,
      },
      {
        blogID: 10,
        blogTitle: i18n.t(`blogPostArray[10].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[10].blogPreview`),
        blogHTML: [
          {
            chapterTitle: i18n.t(`blogPostArray[10].blogHTML[0].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[10].blogHTML[0].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[10].blogHTML[1].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[10].blogHTML[1].chapterHTML`),
          }
        ],
        blogCoverPhoto: "external-articles/wochenblatt-33-jahre",
        blogAdditionalPhotos: null,
        sourceLink: "https://wochenblatt.pl/33-jahre-av-salia-silesia-gleiwitz-zu-oppeln/",
        externalSource: true,
      },
      {
        blogID: 11,
        blogTitle: i18n.t(`blogPostArray[11].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[11].blogPreview`),
        blogHTML: [
          {
            chapterTitle: i18n.t(`blogPostArray[11].blogHTML[0].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[11].blogHTML[0].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[11].blogHTML[1].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[11].blogHTML[1].chapterHTML`),
          }
        ],
        blogCoverPhoto: "external-articles/wochenblatt-pilgrim",
        blogAdditionalPhotos: null,
        sourceLink: "https://wochenblatt.pl/de/ein-pilgertreffen-voller-symbolkraft/",
        externalSource: true,
      },
      {
        blogID: 12,
        blogTitle: i18n.t(`blogPostArray[12].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[12].blogPreview`),
        blogHTML: [
          {
            chapterTitle: i18n.t(`blogPostArray[12].blogHTML[0].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[12].blogHTML[0].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[12].blogHTML[1].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[12].blogHTML[1].chapterHTML`),
          }
        ],
        blogCoverPhoto: "external-articles/wochenblatt-rheno-palatia",
        blogAdditionalPhotos: null,
        sourceLink: "https://wochenblatt.pl/breslau-heimat-der-rheno-palatia/",
        externalSource: true,
      },
      {
        blogID: 13,
        blogTitle: i18n.t(`blogPostArray[13].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[13].blogPreview`),
        blogHTML: [
          {
            chapterTitle: i18n.t(`blogPostArray[13].blogHTML[0].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[13].blogHTML[0].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[13].blogHTML[1].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[13].blogHTML[1].chapterHTML`),
          }
        ],
        blogCoverPhoto: "external-articles/wochenblatt-schlesien-herzen",
        blogAdditionalPhotos: null,
        sourceLink: "https://wochenblatt.pl/schlesien-im-herzen/",
        externalSource: true,
      },
      {
        blogID: 14,
        blogTitle: i18n.t(`blogPostArray[14].blogTitle`),
        blogPreview: i18n.t(`blogPostArray[14].blogPreview`),
        blogHTML: [
          {
            chapterTitle: i18n.t(`blogPostArray[14].blogHTML[0].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[14].blogHTML[0].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[14].blogHTML[1].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[14].blogHTML[1].chapterHTML`),
          },
          {
            chapterTitle: i18n.t(`blogPostArray[14].blogHTML[2].chapterTitle`),
            chapterHTML: i18n.t(`blogPostArray[14].blogHTML[2].chapterHTML`),
          }
        ],
        blogCoverPhoto: "external-articles/dfk-lubowice-35-anniversary",
        blogAdditionalPhotos: null,
        sourceLink: "https://www.naszraciborz.pl/site/art/1-aktualnosci/0-/118967-dzien-kultury-niemieckiej-w-lubowicach-zjechali-czlonkowie-dfk-z-calego-regionu",
        youtubeVideo: "XRB_43epmBc",
        externalSource: true,
      },
    ],
  },
  getters: {
    priorityFeed: (state) => (blogID) => {
      return state.blogPostArray.find(blog => blog.blogID === blogID);
    },
    // Get blog posts for home page feed (excluding welcome screen post)
    blogPostFeed(state) {
      return state.blogPostArray
        .slice(UI_LIMITS.BLOG_FEED_START, UI_LIMITS.BLOG_FEED_START + UI_LIMITS.HOME_BLOG_POSTS);
    },
    // Get limited number of blog cards for display sections, sorted by date (newest first)
    blogPostCards(state) {
      // Helper function to parse German and English date formats
      const parseGermanDate = (dateStr) => {
        const germanMonthNames = {
          'Januar': 0, 'Februar': 1, 'März': 2, 'April': 3, 'Mai': 4, 'Juni': 5,
          'Juli': 6, 'August': 7, 'September': 8, 'Oktober': 9, 'November': 10, 'Dezember': 11
        };

        const englishMonthNames = {
          'January': 0, 'February': 1, 'March': 2, 'April': 3, 'May': 4, 'June': 5,
          'July': 6, 'August': 7, 'September': 8, 'October': 9, 'November': 10, 'December': 11
        };

        const parts = dateStr.split(' ');
        if (parts.length === 3) {
          const monthName = parts[0];
          const month = germanMonthNames[monthName] !== undefined ? germanMonthNames[monthName] : englishMonthNames[monthName];
          const day = parseInt(parts[1].replace(',', ''));
          const year = parseInt(parts[2]);

          if (month !== undefined) {
            return new Date(year, month, day);
          }
        }
        // Fallback to native Date parsing
        return new Date(dateStr);
      };

      return state.blogCardsArray
        .slice() // Create a copy to avoid mutating the original array
        .sort((a, b) => {
          const dateA = parseGermanDate(a.blogDate);
          const dateB = parseGermanDate(b.blogDate);
          // Newest first: if dateB is newer than dateA, return positive (dateB should come first)
          return dateB.getTime() - dateA.getTime();
        })
        .slice(0, UI_LIMITS.BLOG_CARDS_MAX);
    },
    // Get Aktivitas contact cards (first group)
    contactCardsAktivitas(state) {
      return state.contactCardsArray.slice(0, UI_LIMITS.AKTIVITAS_CONTACTS);
    },
    // Get Philister contact cards (second group)
    contactCardsPhilister(state) {
      return state.contactCardsArray.slice(UI_LIMITS.PHILISTER_CONTACTS_START, UI_LIMITS.PHILISTER_CONTACTS_END);
    },
    // translatedBlogCardsArray: (state, getters) => {
    //   const locale = i18n.locale;
    //   return state.items.map(item => ({
    //     title: i18n.t(item.title)
    //   }))
    // } 
    getLanguage: state => state.language
  },
  mutations: {
    changeLanguage (state, data) {
      this.state.language = data
    }
  },
  actions: {
    changeLanguage: ({ commit }, data) => commit('changeLanguage', data)
  },
  modules: {
  }
})
